import { render, staticRenderFns } from "./loginModal.vue?vue&type=template&id=32a211aa"
import script from "./loginModal.vue?vue&type=script&lang=js"
export * from "./loginModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default,LoginToggle: require('/vercel/path0/components/loginToggle.vue').default,Field: require('/vercel/path0/components/ui/field.vue').default,PrimaryButton: require('/vercel/path0/components/ui/primaryButton.vue').default})
